'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _reactIntl = require('react-intl');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BuyersPremium = require('./BuyersPremium.scss');

var _BuyersPremium2 = _interopRequireDefault(_BuyersPremium);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BuyersPremium = (_temp2 = _class = function (_PureComponent) {
    (0, _inherits3.default)(BuyersPremium, _PureComponent);

    function BuyersPremium() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BuyersPremium);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BuyersPremium.__proto__ || (0, _getPrototypeOf2.default)(BuyersPremium)).call.apply(_ref, [this].concat(args))), _this), _this.mapPremiums = function (premium, index) {
            return (0, _jsx3.default)('li', {}, index, premium.percentage, ' ', premium.cutoff);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(BuyersPremium, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                currency = _props.currency,
                low = _props.low,
                lowCutoff = _props.lowCutoff,
                middle = _props.middle,
                middleCutoff = _props.middleCutoff,
                high = _props.high;

            var premiums = [{
                percentage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'low_percentage',
                    values: { low: low }
                })
            }];

            if (low && lowCutoff) {
                premiums = [{
                    cutoff: (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                        value: lowCutoff,
                        style: 'currency',
                        currency: currency
                    }),
                    percentage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'low_cut_off',
                        values: { low: low }
                    })
                }];
            }

            if (middle && middleCutoff) {
                premiums.push({
                    cutoff: (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                        value: middleCutoff,
                        style: 'currency',
                        currency: currency
                    }),
                    percentage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'middle_cut_off',
                        values: { middle: middle }
                    })
                });
            }

            if (middle && !middleCutoff) {
                premiums.push({
                    cutoff: (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                        value: lowCutoff,
                        style: 'currency',
                        currency: currency
                    }),
                    percentage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'middle_low_cut_off',
                        values: { middle: middle }
                    })
                });
            }

            if (high) {
                premiums.push({
                    cutoff: (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                        value: middleCutoff,
                        style: 'currency',
                        currency: currency
                    }),
                    percentage: (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'high_cut_off',
                        values: { high: high }
                    })
                });
            }

            return (0, _jsx3.default)('ul', {
                className: _BuyersPremium2.default['buyers-premium']
            }, void 0, premiums.map(this.mapPremiums));
        }
    }]);
    return BuyersPremium;
}(_react.PureComponent), _class.defaultProps = {
    low: 0
}, _temp2);
exports.default = BuyersPremium;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BuyersPremium/BuyersPremium.js
// module id = Tlyl
// module chunks = 57